import React from "react";
import { CustomDiv } from "../../chat-bot/style";
import { Typography } from "@mui/material";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import CommonButton from "../../../component/Button";
import TalairoLogo from "../../../assets/images/TalairoLogoIco.png";

export default function Introduction({ handleSkip, handleNext }) {
  return (
    <CustomDiv
      style={{
        backgroundImage: `url(${TalairoLogo})`,
        backgroundSize: "auto",
        backgroundPosition: "left bottom",
        backgroundRepeat: "no-repeat",
      }}
      height="100%"
    >
      <Typography
        variant="h1"
        fontSize={"32px"}
        sx={{
          background: "linear-gradient(98.47deg, #5A35B2 1.87%, #FA4F96 54.6%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontWeight: 700,
        }}
      >
        Welcome to Titan Data !
      </Typography>
      <CommonGrid2
        container
        spacing={3}
        marginTop={"2rem"}
        flexDirection={"column"}
      >
        <Typography variant="body7" textAlign={"justify"} lineHeight={"1.8rem"}>
          We believe agencies deserve technology that works at their speed—not
          the other way around. We exist to bring clarity, agility, and
          intelligence back to hiring—so agencies can focus on what they do
          best: placing great talent, fast.
        </Typography>
        <Typography variant="body7" textAlign={"justify"} lineHeight={"1.8rem"}>
          We have designed for simplicity first, with most actions completed in
          3 steps or less. We use a patented AI model to deliver real-time
          insights and value based outcomes and we do that by integrating the
          most powerful tools of an ATS, CRM, VMS, and talent intelligence
          platform into one light, recruiter-first experience.
        </Typography>
        <Typography variant="body7" textAlign={"justify"} lineHeight={"1.8rem"}>
          And we protect your data with a private agency ecosystem, so your
          insights stay yours
        </Typography>

        <Typography
          variant="body7"
          textAlign={"justify"}
          lineHeight={"1.8rem"}
          marginTop={"-1rem"}
        >
          Our Product. Your Differentiation.
        </Typography>
      </CommonGrid2>

      <CommonGrid2
        display={"flex"}
        gap={"1rem"}
        marginTop={"4rem"}
        justifyContent={"end"}
      >
        <CommonButton
          value={"Skip"}
          padding={"10px 5rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          background={"transparent"}
          boxShadow={"none"}
          color="#6941C6"
          onClick={handleSkip}
          customStyle={{
            "&:hover": {
              boxShadow: "none",
            },
          }}
        />
        <CommonButton
          value={"Next"}
          padding={"10px 5rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          onClick={handleNext}
        />
      </CommonGrid2>
    </CustomDiv>
  );
}
